import { render } from "./edit.vue?vue&type=template&id=af5cbf66&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=af5cbf66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af5cbf66"

export default script